import { useLocalStorage } from '@vueuse/core';
import { ref, watch } from 'vue';

const RECENT_SEARCHES_STORAGE_KEY = 'recentSearches';
const MAX_RECENT_SEARCHES_COUNT = 4;
// Shared state across all instances of the composable
const isRecentSearchesVisible = ref(false);

export const useRecentSearches = (isSearchInputFocused, hasSearched) => {
  const recentSearches = useLocalStorage(RECENT_SEARCHES_STORAGE_KEY, []);

  watch([isSearchInputFocused, hasSearched], ([isFocused, isSearched]) => {
    if (isFocused && isSearched) {
      isRecentSearchesVisible.value = recentSearches.value?.length > 0;
    }
  });

  /**
   * Adds the current search query to the list of recent searches if it is not empty and not already present.
   * Maintains only the 4 latest recent searches using slice.
   *
   * @returns {void}
   */
  const addToRecentSearches = (searchQuery) => {
    const trimmedSearchQuery = searchQuery?.trim();

    if (!trimmedSearchQuery?.length || recentSearches.value.includes(trimmedSearchQuery)) {
      return;
    }

    recentSearches.value = [trimmedSearchQuery, ...recentSearches.value].slice(0, MAX_RECENT_SEARCHES_COUNT);
  };

  const closeRecentSearchesDropdown = () => {
    isRecentSearchesVisible.value = false;
  };

  return { recentSearches, isRecentSearchesVisible, addToRecentSearches, closeRecentSearchesDropdown };
};
